import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '../../../data/services/shared-data.service';
import { AccountIntegrationsStoresService } from './../../account/integrations/feat-account-integrations/domain/apis/account-integrations.stores';

@Component({
    selector: 'app-integrations-active',
    templateUrl: './sidebar2-integrations-active.component.html',
    standalone: false,
})
export class Sidebar2IntegrationsActiveComponent implements OnInit {
    // @ts-ignore TS7008
    subExecutingSync;
    // @ts-ignore TS7008
    isAccountSyncing;
    // @ts-ignore TS7008
    subIsAccountDisconnected;
    // @ts-ignore TS7008
    subIsSyncIntegrationCompleted;
    // @ts-ignore TS7008
    integrations;

    constructor(
        private sharedData: SharedDataService,
        private accountIntegrationsStoresService: AccountIntegrationsStoresService
    ) {}

    ngOnInit() {
        this.subExecutingSync = this.accountIntegrationsStoresService.isAccountSyncing$.subscribe((isAccountSyncing) => {
            this.isAccountSyncing = isAccountSyncing;
        });

        this.subIsAccountDisconnected = this.accountIntegrationsStoresService.isAccountDisconnected$.subscribe(() => {
            this.load();
        });

        this.subIsSyncIntegrationCompleted = this.accountIntegrationsStoresService.isSyncIntegrationCompleted$.subscribe(() => {
            this.load();
        });

        this.load();
    }

    ngOnDestroy() {
        if (this.subExecutingSync) {
            this.subExecutingSync.unsubscribe();
        }

        if (this.subIsAccountDisconnected) {
            this.subIsAccountDisconnected.unsubscribe();
        }

        if (this.subIsSyncIntegrationCompleted) {
            this.subIsSyncIntegrationCompleted.unsubscribe();
        }
    }

    load() {
        this.integrations = this.sharedData.Integrations;
    }

    // @ts-ignore TS7006
    doAction(integration, action) {
        // Disables the Sync button straight away to avoid sync spams
        this.isAccountSyncing = true;
        this.accountIntegrationsStoresService.executeAccountsSync();
    }
}
